"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CustomError", {
  enumerable: true,
  get: function get() {
    return _CustomError.default;
  }
});
Object.defineProperty(exports, "Forbidden", {
  enumerable: true,
  get: function get() {
    return _Forbidden.default;
  }
});
Object.defineProperty(exports, "NotFound", {
  enumerable: true,
  get: function get() {
    return _NotFound.default;
  }
});
Object.defineProperty(exports, "ServerError", {
  enumerable: true,
  get: function get() {
    return _ServerError.default;
  }
});
var _CustomError = _interopRequireDefault(require("./CustomError"));
var _NotFound = _interopRequireDefault(require("./NotFound"));
var _Forbidden = _interopRequireDefault(require("./Forbidden"));
var _ServerError = _interopRequireDefault(require("./ServerError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }